"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
var _react = _interopRequireWildcard(require("react"));
var _button = require("@citrus/button");
var _icon = require("@citrus/icon");
var _html = require("@citrus/html");
var _inputWysiwyg = require("@citrus/input-wysiwyg");
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Constants");
var _PctyQuestionBuilder2 = require("./PctyQuestionBuilder.Common");
var _Icon, _div;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    content = _ref.content,
    videoId = _ref.videoId,
    editable = _ref.editable,
    drawerMode = _ref.drawerMode,
    onQuestionUpdated = _ref.onQuestionUpdated,
    onGetSingleManageVideoToken = _ref.onGetSingleManageVideoToken,
    onVideoDoneHandler = _ref.onVideoDoneHandler,
    videoStudioEnabled = _ref.videoStudioEnabled;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.video;
  var questionTypeInfo = _PctyQuestionBuilder.QUESTION_TYPES_LIST.find(function (x) {
    return x.questionTypeId === questionTypeId;
  });
  var _onChange = function onChange(rawContent) {
    var updatedContent = (0, _inputWysiwyg.toHtml)(rawContent);
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: updatedContent
    });
  };
  var getManageVideoToken = function getManageVideoToken() {
    try {
      if (onGetSingleManageVideoToken && (0, _isNotNullOrEmpty.default)(videoId)) {
        onGetSingleManageVideoToken(videoId).then(function (response) {
          setManageToken(response.token);
          var token = response.token;

          // wait a bit for the dom to settle
          setTimeout(function (token) {
            if (window.VidGrid && token && token.length > 0) {
              window.VidGrid.initPlayer("#video_player-tfv2-".concat(id), {
                videoId: videoId,
                token: token
              });
            } else {
              console.error("window.VidGrid was not found! Are you sure you loaded it?");
            }
          }, 500, token);
        });
      }
    } catch (_unused) {}
  };
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    manageToken = _useState2[0],
    setManageToken = _useState2[1];

  // fetch a new manageToken if the videoId has changed (may not need!)
  (0, _react.useEffect)(function () {
    var unmounted = false;
    getManageVideoToken();
    return function () {
      unmounted = true;
    };
  }, [videoId]);
  var onVideoActionDone = function onVideoActionDone(videoEvent) {
    setManageToken(videoEvent.token);
    onVideoDoneHandler(videoEvent);
  };
  var onClickAddVideo = function onClickAddVideo() {
    if (window.pctyVideo) {
      if (videoStudioEnabled) {
        //onRecord, onUpload, and onCancel are optional callbacks and are null in videoCreator V3
        window.pctyVideo.createVideo(null, null, onVideoActionDone, null, {
          showScreenRecorder: true,
          showHubSelector: true,
          product: "TalentFormsApi",
          videoOptions: {
            public: true
          }
        });
      } else {
        //onRecord, onUpload, and onCancel are optional callbacks and are null in videoCreator V3
        window.pctyVideo.createVideo(null, null, onVideoActionDone, null, {
          product: "TalentFormsApi"
        });
      }
    } else {
      console.error("window.pctyVideo was not found! Are you sure you loaded it?");
    }
  };
  var onRemoveVideo = function onRemoveVideo() {
    setManageToken('');
    onVideoDoneHandler({});
  };
  var renderVideoArea = function renderVideoArea() {
    if ((0, _isNotNullOrEmpty.default)(videoId) && (0, _isNotNullOrEmpty.default)(manageToken)) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-edit-question-video-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-edit-question-video"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "remove-video"
      }, editable && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
        onClick: function onClick() {
          return onRemoveVideo();
        }
      }, _Icon || (_Icon = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
        title: "video",
        name: "video"
      })), "Remove")), /*#__PURE__*/_react.default.createElement("vidgrid-player-instance", {
        id: "video_player-tfv2-".concat(id),
        "video-id": videoId,
        token: manageToken
      })));
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "empty-video"
      }, _div || (_div = /*#__PURE__*/_react.default.createElement("div", {
        className: "caption"
      }, /*#__PURE__*/_react.default.createElement("p", null, "Record or Upload Video"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "add-video"
      }, /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
        onClick: function onClick() {
          return onClickAddVideo();
        }
      }, "Add Video")));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: drawerMode ? "pcty-question-builder-video-widget-drawer" : "pcty-question-builder-video-widget"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: '15px'
    }
  }, editable ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
    className: "pcty-input-label question-display-label"
  }, questionTypeInfo.label), /*#__PURE__*/_react.default.createElement(_inputWysiwyg.Wysiwyg, {
    style: {
      marginTop: '10px'
    },
    id: id + '-video-wysiwyg',
    key: id + '-video-wysiwyg-key',
    onChange: function onChange(rc) {
      return _onChange(rc);
    },
    placeholder: "Please enter your text",
    rawContentState: !!content ? (0, _inputWysiwyg.fromHtml)(content) : null,
    toolbar: ['bold', 'italic', 'underline', 'unordered-list', 'ordered-list', 'undo', 'redo']
  })) : /*#__PURE__*/_react.default.createElement(_html.Html, {
    content: (0, _PctyQuestionBuilder2.replaceEmptyPTags)(content),
    id: id + '-video-title',
    style: {
      display: 'inline-block'
    },
    type: "html"
  })), renderVideoArea());
};
var _default = exports.default = Presentational;